import { IAppTheme } from '@msx/platform-services';

export const getStyles = (theme: IAppTheme) => {
    return {
        iconProp: {
            selectors: {
                ':hover': {
                    '.ms-Button-menuIcon': {
                        background: "transparent",
                    }
                },
                '.ms-Button-menuIcon': {
                    color: "#FFFFFF !important"
                }
            },
            '& .ms-Button-flexContainer': {
                width: `100% !important`
            }
        },
        headerButton: {
            '& .ms-Button-flexContainer': {
                width: `100% !important`
            }
        },
        helpDropdown: {
            backgroundColor: "#FFFFFF",
            padding: "10px 0px 0px 15px",
            borderRadius: "4px",
            width: "220px",
            boxShadow: "0px 3.2px 7.2px 0px #00000021",
            marginTop: "50px",
            // marginLeft: "81%",
            maxWidth: "calc(100% - 20px)", // Ensure the dropdown doesn't exceed the viewport width
            marginLeft: "auto", // Align to the right edge
            marginRight: "10px", // Add some space from the right edge
            '@media (max-width: 768px)': {
                marginLeft: "10px",
                marginRight: "auto",
            },
        },
        helpList: {
            fontSize: "14px",
            color: "#323130"
        },
        helpIcon: {
            '@media (max-width: 600px)': {
                display: 'block !important',
            }

        },
        linkStyle:{
            background: 'none',
            color: '#0d6efd',
            textDecoration: 'underline',
            border: 'none',
            cursor: 'pointer',
            fontSize: 'inherit',
            fontFamily: 'inherit',
            backgroundColor: 'transparent',
            margin:'0px 0px 15px 10px',
            display: 'block',
        },
        appNameStyle: {
            cursor: 'pointer',
            color: theme?.name === 'dark' ? '#242424' : '#ffffff'
        },
        headerTitleContainer: {
            display: 'flex',
            alignItems: 'center',
            gap: '10px'
        },
        headerLogo: {
            height: '32px',
            width: '32px',
            objectFit: 'cover' as const,
            borderRadius: '6px',
            backgroundColor: '#ffffff',
            padding: '2px',
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.25)',
            display: 'block'
        },
        profilePersona: {
            '.ms-Persona-initials span': {
                color: '#010100'
            }
        }

    }
};
